export default __webpack_public_path__ + "static/media/WhatsApp.209deaad.svg";